import { useMemo, useState } from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import {
  FieldSelect as LookerSelect,
  type SelectOptionObject,
} from '@looker/components';

import { GetAllVehicles } from '@/api/fe-api/view/queries/get-all-vehicles';
import { cls } from '@/utils/cls';

import style from '@/components/looker/styles.module.scss';

export function VehicleSelection() {
  const history = useHistory();
  const { siteId } = useParams<{ siteId?: string }>();
  const [inputFilter, setInputFilter] = useState('');
  const { data: vehicles, isLoading } = GetAllVehicles.useQuery();
  const options = useMemo<SelectOptionObject[]>(
    () =>
      vehicles
        ?.map(({ fullFrontendId }) => ({
          value: fullFrontendId,
        }))
        .sort((a, b) => a.value.localeCompare(b.value)) ?? [],
    [vehicles],
  );

  const filteredOptions = useMemo(
    function () {
      const lowercasedFilter = inputFilter.toLowerCase();
      return options.filter((option) =>
        (option.label ?? option.value).toLowerCase().includes(lowercasedFilter),
      );
    },
    [inputFilter, options],
  );

  function onVehicleSearchSuccess(vehicleId: string) {
    history.push(generatePath('/vehicle/:id', { id: vehicleId }));
  }

  return (
    <LookerSelect
      className={cls({
        [style.fieldSelectDark]: siteId,
        [style.fieldSelect]: !siteId,
        [style.value]: siteId,
      })}
      onFilter={setInputFilter}
      options={filteredOptions}
      isFilterable={true}
      placeholder={siteId ?? 'Fleet'}
      isLoading={isLoading}
      onChange={(id: string) => onVehicleSearchSuccess(id)}
    />
  );
}
